import React from "react";
import PropTypes from "prop-types";

import {
  getChannel,
  getSegment,
  installmentFormatter,
  isControlChannel,
} from "../../../../lib/utils";

import cellImg from "../../../../images/mc-confirmation-celular-black.svg";
import CardBox from "../../../shared/CardBox/CardBox";
import {
  CellImgElement,
  RechargeValuePriceElement,
  RechargeValueBonusElement,
  RechargeValueButtonElement,
  RechargeValueValidateElement,
} from "./RechargeValue.styles";
import { getBonus, haveBonus } from "../../../../selectors/customer";

const RechargeValue = ({ rechargeValue, onClick }) => {
  const channel = getChannel();
  const segment = getSegment();

  const bonusText =
    !isControlChannel(channel) &&
    haveBonus(rechargeValue.value, null, null, channel) &&
    getBonus(rechargeValue.value, channel, segment);

  return (
    <CardBox>
      <CellImgElement src={cellImg} alt="" />
      <RechargeValuePriceElement>
        {installmentFormatter(rechargeValue.value)}
      </RechargeValuePriceElement>
      {bonusText && <RechargeValueBonusElement>{bonusText}</RechargeValueBonusElement>}
      <RechargeValueButtonElement
        haveBonus={bonusText}
        onClick={() => {
          onClick(rechargeValue);
        }}
        text="Recarregar"
      />
      {rechargeValue && rechargeValue.custom_attributes.reload_validity && (
        <RechargeValueValidateElement>
          Recarga válida por {rechargeValue.custom_attributes.reload_validity} dias.
          {rechargeValue.custom_attributes?.info}
        </RechargeValueValidateElement>
      )}
    </CardBox>
  );
};

RechargeValue.propTypes = {
  rechargeValue: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default RechargeValue;
